import { Text } from '@chakra-ui/react';
import type { Msg } from '@halo/chat-sdk-react';
import { MyTrans } from '@halo/ui-react';
import { MsgUserText } from '../../msg-parts';

export interface MsgGroupCreateContentProps {
  message: Msg;
}

export const MsgGroupCreateContent = memo(function MsgGroupCreateContent({
  message,
}: MsgGroupCreateContentProps) {
  const { user_name, user_id } = message.payload;

  return (
    <MyTrans
      i18nKey="chat.groupMessageCreateText"
      components={{
        actionUser: <MsgUserText userName={user_name} userId={user_id} />,
        action: <Text as="span" color="fg.muted" />,
      }}
    ></MyTrans>
  );
});
